import PropTypes from "prop-types";

import AppThemeDialog from "./AccountAppTheme/AppThemeDialog";

import {
  CREATE_ACCOUNT_APP_THEME,
  GET_ACCOUNT_APP_CONTENT_QUERY_NAME,
  GET_ACCOUNT_FILES_NAME,
} from "graphqlQueries/accountFiles";

const CreateAccountAppTheme = ({ onClose, accountId }) => {
  return (
    <AppThemeDialog
      mutation={CREATE_ACCOUNT_APP_THEME}
      onClose={onClose}
      accountId={accountId}
      refetchQuery={[
        GET_ACCOUNT_FILES_NAME,
        GET_ACCOUNT_APP_CONTENT_QUERY_NAME,
      ]}
    ></AppThemeDialog>
  );
};

CreateAccountAppTheme.propTypes = {
  onClose: PropTypes.func.isRequired,
  accountId: PropTypes.number.isRequired,
};

export default CreateAccountAppTheme;
